import { render, staticRenderFns } from "./ButtonERC1155.vue?vue&type=template&id=096066d4"
import script from "./ButtonERC1155.vue?vue&type=script&lang=js"
export * from "./ButtonERC1155.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports